import { t } from '@/core/localization';
import { StickerState } from '@/shared/models';
export const getStickerStateName = (stickerState) => {
    switch (stickerState) {
        case StickerState.Receipted:
            return t('receipted.sticker.status');
        case StickerState.Placed:
            return t('placed.sticker.status');
        // TODO: to delete later
        // case StickerState.Picked:
        // 	return t('picked.sticker.status');
        case StickerState.Packed:
            return t('packed.sticker.status');
        case StickerState.AddedToRealization:
            return t('added.to.realization.sticker.status');
        case StickerState.Shipped:
            return t('shipped.sticker.status');
        case StickerState.PlacedOnStock:
        case StickerState.ReturnFromCustomer:
        case StickerState.CanceledByCustomer:
        case StickerState.ReceivedAtDeliveryPoint:
        case StickerState.HandedToCustomer:
        case StickerState.SentToPartnerDeliveryService:
            return 'Unknown sticker status';
        case StickerState.Unknown:
            return 'Unknown receipt status';
        default: {
            stickerState;
            return 'Unknown receipt status';
            // throw new Error(`Unhandled StickerState case: ${exhaustiveCheck}`);
        }
    }
};
